import React, { useEffect, useState } from "react";
import Card from "components/card";
import { getNotifications } from "services/notifications";

const UserNotifications: React.FC = () => {
  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const data = await getNotifications();
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : data || [];
        if (mounted) setNotifications(list);
      } catch (err) {
        console.error(err);
        if (mounted) setNotifications([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Card extra="w-full p-4">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Notifications</h1>
        <p className="text-sm text-gray-500">
          Recent notifications for your account
        </p>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : notifications.length === 0 ? (
        <div className="text-sm text-gray-500">No notifications</div>
      ) : (
        <div className="space-y-3">
          {notifications.map((n) => (
            <article
              key={n.id || n.created_at}
              className="rounded bg-white p-3 shadow-sm dark:bg-navy-700"
            >
              <div className="flex items-start gap-3">
                <div className="text-2xl">🔔</div>
                <div>
                  <div className="font-semibold">
                    {n.title || n.type || "Notification"}
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-300">
                    {n.body || n.message}
                  </div>
                  <div className="mt-1 text-xs text-gray-400">
                    {n.created_at
                      ? new Date(n.created_at).toLocaleString()
                      : ""}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </Card>
  );
};

export default UserNotifications;
